import styled from 'styled-components';

import indexBuriedPoint from '@/utils/_indexBuriedPoint';
import { buriedPoint } from '@/utils/buriedPoint';

const Content = styled.section`
  #ad-link {
    position: relative;
    background: url(//static.szlcsc.com/ecp/assets/web/layout/websiteGroupDialog/images/top.png) no-repeat;
    background-size: 444px 224px;
    padding-top: 140px;
    .line {
      position: absolute;
      top: 118px;
      left: 8%;
      width: 370px;
      height: 22px;
      background: #bf0909;
      box-shadow:
        inset 0px 0px 1px 1px rgba(164, 0, 0, 1),
        inset 0px 0px 1px 0px rgba(255, 255, 255, 1);
      border-radius: 15px;
    }
    .card-wrap {
      width: 444px;
      .card {
        width: 350px;
        background: linear-gradient(177deg, #fe795a 0%, #ff4753 100%);
        border-radius: 0px 0px 1px 1px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        margin: 0 auto;
        .card-top {
          width: 100%;
          height: 8px;
          background: linear-gradient(180deg, #a50505 0%, rgba(185, 15, 15, 0.48) 48%, rgba(191, 9, 9, 0) 100%);
        }
        .card-title {
          width: 308px;
          height: 67px;
          background: url(//static.szlcsc.com/ecp/assets/web/layout/websiteGroupDialog/images/text.png) no-repeat;
          &.jlc-act {
            background: url(//static.szlcsc.com/ecp/assets/web/layout/websiteGroupDialog/images/jlc-act-title.png)
              no-repeat;
          }
        }
        .list {
          width: 300px;
          height: 70px;
          background: url(//static.szlcsc.com/ecp/assets/web/layout/websiteGroupDialog/images/card.png) no-repeat;
          background-size: 100% 100%;
          display: flex;
          align-items: center;
          .list-left {
            text-align: center;
            width: 30%;
            .price {
              font-weight: bold;
              color: #ff5d56;
              font-size: 24px;
            }
            .unit {
              color: #ff5d56;
              font-size: 14px;
            }
          }
          .list-right {
            width: 70%;
            .coupon-title {
              font-weight: bold;
              color: #444444;
              font-size: 14px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .coupon-limit {
              font-weight: bold;
              color: #666666;
              font-size: 12px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .coupon-time {
              font-weight: bold;
              color: #666666;
              font-size: 12px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }
        .list2 {
          width: 300px;
          height: 70px;
          background: url(//static.szlcsc.com/ecp/assets/web/layout/websiteGroupDialog/images/card2.png) no-repeat;
          background-size: 100% 100%;
          display: flex;
          align-items: center;
          .list-left {
            text-align: center;
            width: 30%;
            .price {
              font-weight: bold;
              color: #ff5d56;
              font-size: 24px;
            }
            .unit {
              color: #ff5d56;
              font-size: 14px;
            }
          }
          .list-right {
            width: 70%;
            .coupon-title {
              font-weight: bold;
              color: #444444;
              font-size: 14px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .coupon-limit {
              font-weight: bold;
              color: #666666;
              font-size: 12px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .coupon-time {
              font-weight: bold;
              color: #666666;
              font-size: 12px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }
        .website-group-dialog-btn {
          width: 190px;
          height: 50px;
          background: #ff8c25;
          border-radius: 30px;
          color: white;
          line-height: 50px;
          font-size: 18px;
          margin: 40px 0 30px 0;
          font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
          font-weight: bold;
        }
      }
    }
    > img {
      max-height: 100%;
      max-width: 100%;
    }
  }
`;

const GroupSendCoupon = ({ data, targetLink }) => {
  function handleClick() {
    indexBuriedPoint('Group_advertising', targetLink, 'click', 'open');
    buriedPoint({
      ty: 'view',
      cp: 'float_adv',
      op: 'window_in_central',
      pf: 'pc',
      data: { Based_id: data.autoSubgroupId, hf: targetLink },
    });
  }
  if (data) {
    const { couponList } = data;
    if (couponList) {
      return (
        <Content>
          <div id="ad-link">
            <div className="line"></div>
            <div className="card-wrap">
              <div className="card">
                <div className="card-top"></div>
                <div className="card-title"></div>
                <div className="out-list">
                  {couponList.map((coupon, idx) => {
                    let leftDom = (
                      <>
                        <span className="price">{coupon.couponAmount}</span>
                        <span className="unit">元</span>
                      </>
                    );
                    if (coupon.couponType === 'freight' && coupon.isFreeExpress) {
                      leftDom = (
                        <>
                          <span className="price">包邮</span>
                        </>
                      );
                    }
                    if (coupon.couponType === 'discount') {
                      leftDom = (
                        <>
                          <span className="price">{coupon.couponDiscount * 10}</span>
                          <span className="unit">折</span>
                        </>
                      );
                    }
                    return (
                      <div className="list2" key={idx}>
                        <div className="list-left">{leftDom}</div>
                        <div className="list-right">
                          <div className="coupon-title">{coupon.couponName}</div>
                          <div className="coupon-limit">满{coupon.minOrderMoney}可用</div>
                          <div className="coupon-time">有效期至：{coupon.couponValidEndTime}</div>
                        </div>
                      </div>
                    );
                  })}
                </div>
                <a
                  href={targetLink}
                  className="website-group-dialog-btn text-center"
                  rel="nofollow"
                  onClick={handleClick}
                  target="_blank"
                >
                  立即查看
                </a>
              </div>
            </div>
          </div>
        </Content>
      );
    }
  }
  return <></>;
};

export default GroupSendCoupon;
